// extracted by mini-css-extract-plugin
module.exports = {"emptySection":"MenuList_emptySection__fspgf","listWrapper":"MenuList_listWrapper__C2Wr1"};